import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import AdminLayout from "@/components/feature/AdminLayout";
import Login from "@/pages/login/page";
import Dashboard from "@/pages/dashboard/page";
import Domains from "@/pages/domains/page";
import Analytics from "@/pages/analytics/page";
import Settings from "@/pages/settings/page";
import GoPage from "@/pages/go/page";

const routes: RouteObject[] = [
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/go/:id",
    element: <GoPage />,
  },
  {
    path: "/",
    element: <AdminLayout />,
    children: [
      { index: true, element: <Dashboard /> },
      { path: "domains", element: <Domains /> },
      { path: "analytics", element: <Analytics /> },
      { path: "settings", element: <Settings /> },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;